/**
 * Front-end framework hint surfaced on the Run report.
 * Backend writes this once per run on the first successful goto step.
 */
const FRAMEWORK_STYLE = {
  React: { bg: "#61DAFB1F", fg: "#0284C7", border: "#61DAFB66" },
  "Next.js": { bg: "#0F172A", fg: "#FFFFFF", border: "#0F172A" },
  Angular: { bg: "#DD003114", fg: "#B91C1C", border: "#DD003140" },
  AngularJS: { bg: "#DD003114", fg: "#B91C1C", border: "#DD003140" },
  Vue: { bg: "#42B8831F", fg: "#047857", border: "#42B88366" },
  "Nuxt.js": { bg: "#00DC821F", fg: "#047857", border: "#00DC8266" },
  Svelte: { bg: "#FF3E001F", fg: "#C2410C", border: "#FF3E0066" },
};

export function FrameworkBadge({ framework, testId }) {
  if (!framework?.name) return null;
  const fallback = { bg: "#F1F5F9", fg: "#475569", border: "#CBD5E1" };
  const tint = FRAMEWORK_STYLE[framework.name] || fallback;
  return (
    <div data-testid={testId}>
      <span className="text-xs font-medium text-[#64748B]">Framework</span>
      <div className="mt-0.5">
        <span
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-semibold"
          style={{
            backgroundColor: tint.bg,
            color: tint.fg,
            border: `1px solid ${tint.border}`,
          }}
        >
          {framework.name}
          {framework.version && (
            <span className="font-normal opacity-80">v{framework.version}</span>
          )}
        </span>
      </div>
    </div>
  );
}
